import { ResultCodeEnum } from "./V2/gozer"
import { PaymentTransactionTypeEnum } from "./V2/gozer"
import { PaymentProcessStatus } from "./V2/gozer"

export const PaymentStatuses = [
    {
        name: "Approved",
        value: ResultCodeEnum.APPROVED,
        paymentStatusGroup: "Approved",
        paymentStatus: ResultCodeEnum.APPROVED,
        paymentTransactionType: PaymentTransactionTypeEnum.CHARGE,
        paymentProcessStatus: null
    },
    {
        name: "Declined",
        value: ResultCodeEnum.DECLINED,
        paymentStatusGroup: "Declined",
        paymentStatus: ResultCodeEnum.DECLINED,
        paymentTransactionType: PaymentTransactionTypeEnum.CHARGE,
        paymentProcessStatus: null
    },
    {
        name: "Error",
        value: ResultCodeEnum.ERROR,
        paymentStatusGroup: "Error",
        paymentStatus: ResultCodeEnum.ERROR,
        paymentTransactionType: PaymentTransactionTypeEnum.CHARGE,
        paymentProcessStatus: null
    },
    {
        name: "Cancel",
        value: ResultCodeEnum.CANCELED,
        paymentStatusGroup: "Cancel",
        paymentStatus: ResultCodeEnum.CANCELED,
        paymentTransactionType: PaymentTransactionTypeEnum.CHARGE,
        paymentProcessStatus: null
    },
    {
        name: "Pending",
        value: PaymentProcessStatus.PENDING,
        paymentStatusGroup: "Pending",
        paymentStatus: null,
        paymentTransactionType: null,
        paymentProcessStatus: PaymentProcessStatus.PENDING
    },
    {
        name: "Not Defined",
        value: ResultCodeEnum.NONE,
        paymentStatusGroup: "Not Defined",
        paymentStatus: ResultCodeEnum.NONE,
        paymentTransactionType: PaymentTransactionTypeEnum.CHARGE,
        paymentProcessStatus: null
    },
    {
        name: "ACH Return",
        value: "Returned",
        paymentStatusGroup: "ACH Return",
        paymentStatus: null,
        paymentTransactionType: PaymentTransactionTypeEnum.ACHRETURN,
        paymentProcessStatus: null
    },
    {
        name: "Chargeback",
        value: "Returned",
        paymentStatusGroup: "Chargeback",
        paymentStatus: null,
        paymentTransactionType: PaymentTransactionTypeEnum.CHARGEBACK,
        paymentProcessStatus: null
    },
    {
        name: "Funded",
        value: PaymentProcessStatus.FUNDED,
        paymentStatusGroup: "Funded",
        paymentStatus: null,
        paymentTransactionType: null,
        paymentProcessStatus: PaymentProcessStatus.FUNDED
    },
    {
        name: "Void",
        value: "Voided",
        paymentStatusGroup: "Void",
        paymentStatus: ResultCodeEnum.APPROVED,
        paymentTransactionType: PaymentTransactionTypeEnum.VOID,
        paymentProcessStatus: null
    },
    {
        name: "Refund",
        value: "Refunded",
        paymentStatusGroup: "Refund",
        paymentStatus: ResultCodeEnum.APPROVED,
        paymentTransactionType: PaymentTransactionTypeEnum.REFUND,
        paymentProcessStatus: null
    },
    {
        name: "Transfer",
        value: "Reversed",
        paymentStatusGroup: "Transfer",
        paymentStatus: null,
        paymentTransactionType: PaymentTransactionTypeEnum.REVERSAL,
        paymentProcessStatus: null
    }
].sort((a,b) => a?.name?.localeCompare(b?.name ?? "") ?? 0)